<template>
  <div class="form-holder" :class="{ 'bg-white shadow-1': backgroudColor }">
    <header-form
      :is-loading="isLoading"
      :form-name="formName"
      :submit="submit"
      :reset-form="resetForm"
      :button-one-caption="getButtonOneCaption"
      :button-one-icon="buttonOneIcon"
      :button-one-visibility="buttonOneVisibility"
      :button-two-caption="getButtonTwoCaption"
      :button-two-icon="buttonTwoIcon"
      :button-two-visibility="buttonTwoVisibility"
      :button-two-action="buttonTwoAction"
      :button-three-caption="buttonThreeCaption"
      :button-three-icon="buttonThreeIcon"
      :button-three-visibility="buttonThreeVisibility && this.urlResetPathName && this.urlResetPathName !== ''"
      :disable-submit="getDisableSubmit"
      :hide-submit="hideSubmit"
      :button-custom-action-caption="buttonCustomActionCaption"
      :button-custom-action-icon="buttonCustomActionIcon"
      :button-custom-action-actions="buttonCustomActionActions"
      :before-close="beforeClose"
    >
      <template v-slot:right-side>
        <slot name="right-side"></slot>
      </template>
    </header-form>
    <div class="row q-col-gutter-sm">
      <div class="col-12">
        <slot name="form-title" />
      </div>
      <div class="col-12">
        <div :id="formName" :ref="formName" :name="formName">
          <slot name="form" />
        </div>
      </div>
    </div>
    <maintenance v-if="isMaintenanceMode" />
  </div>
</template>
<!-- Component SCRIPT area -->
<script>
import HeaderForm from '../header/formHeader'
import Maintenance from '../notification/maintenance'
import _ from 'lodash'
import { mapActions, mapState } from 'vuex'

export default {
  // Name is important do not delete
  name: 'BasicForm',
  components: {
    HeaderForm,
    Maintenance,
  },
  // Declare component props
  props: {
    enableFieldPermissionCheck: {
      type: Boolean,
      default: false,
    },
    backgroudColor: {
      type: Boolean,
      default: false,
    },
    formFieldData: {
      type: Object,
      required: true,
      default: () => {},
    },
    formName: {
      type: String,
      default: 'Form',
    },
    urlResetPathName: {
      type: String,
      required: true,
    },
    urlResetParams: {
      type: Object,
      default: () => ({}),
    },
    urlResetQueryString: {
      type: Object,
      default: () => ({}),
    },
    formSubmit: {
      type: Function,
      required: true,
    },
    disableSubmit: {
      type: Boolean,
      default: false,
    },
    hideSubmit: {
      type: Boolean,
      default: false,
    },
    buttonOneCaption: {
      type: String,
    },
    buttonOneIcon: {
      type: String,
      required: false,
      default: 'done',
    },
    buttonOneVisibility: {
      type: Boolean,
      required: false,
      default: true,
    },
    buttonTwoCaption: {
      type: String,
    },
    buttonTwoIcon: {
      type: String,
      required: false,
      default: 'done_all',
    },
    buttonTwoVisibility: {
      type: Boolean,
      required: false,
      default: true,
    },
    buttonTwoAction: {
      type: Function,
    },
    buttonThreeCaption: {
      type: String,
      required: false,
      default: function() {
        return this.$t('common.button.cancel')
      },
    },
    buttonThreeIcon: {
      type: String,
      required: false,
      default: 'clear',
    },
    buttonThreeVisibility: {
      type: Boolean,
      required: false,
      default: true,
    },
    buttonCustomActionCaption: {
      type: String,
    },
    buttonCustomActionIcon: {
      type: String,
      required: false,
      default: 'delete',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isMaintenanceMode: {
      type: Boolean,
      default: false,
    },
    buttonCustomActionActions: {
      type: Object,
    },
    isUpdate: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    forceDisableSubmit: false,
  }),
  // Watch field value changes
  watch: {
    formFieldData: {
      // Clear visible validation error by field name once user correct the errors
      handler(obj) {
        if (this.errors) {
          _.forOwn(obj, (value, key) => {
            // For dynamic objects
            if (obj[key] !== null && typeof obj[key] === 'object' && typeof obj[key].length !== 'undefined') {
              obj[key].forEach(item => {
                if (typeof item === 'object') {
                  _.forOwn(item, value => {
                    if (typeof value !== 'undefined' && value && value.length !== 0 && value !== true) {
                      this.clearFormFieldValidation(value)
                    }
                  })
                } else {
                  if (typeof item !== 'undefined' && item && item.length !== 0 && item !== true) {
                    this.clearFormFieldValidation(item)
                  }
                }
              })
            } else {
              if (typeof value !== 'undefined' && value && value.length !== 0 && value !== true) {
                this.clearFormFieldValidation(key)
              }
            }
          })
        }
      },
      // Watch Objects / Array deep value changes
      deep: true,
    },
  },
  computed: {
    // Assign form related data from vuex store state
    ...mapState({
      errors: state => state.globalCMP.errors.data,
    }),
    getButtonOneCaption() {
      return this.buttonOneCaption
        ? this.buttonOneCaption
        : this.isUpdate
        ? this.$t('common.button.update')
        : this.$t('common.button.save')
    },
    getButtonTwoCaption() {
      return this.buttonTwoCaption
        ? this.buttonTwoCaption
        : this.isUpdate
        ? this.$t('common.button.updateAndClose')
        : this.$t('common.button.saveAndClose')
    },
    getDisableSubmit() {
      return this.disableSubmit || this.forceDisableSubmit
    },
  },
  mounted() {
    // Call check permission every 5sec to detect un-detectable ui changes
    setInterval(() => {
      this.checkPermissions()
    }, 1500)
  },
  methods: {
    // Declare vuex actions
    ...mapActions([
      'clearValidationAction',
      'resetErrorsAction',
      'openCloseModalAction',
      'getModuleListAction',
      'currentUpdateIdAction',
    ]),
    // Clear server side form validation errors
    clearFormFieldValidation(name) {
      if (Object.keys(this.errors).length > 0) {
        this.clearValidationAction(name)
      }
    },
    // Reset form fields
    async resetForm() {
      await this.resetErrorsAction()
    },
    // submit any form
    submit(redirect) {
      this.formSubmit(this.formFieldData, redirect)
        .then(() => {
          this.resetAndGo(redirect)
        })
        .catch(() => {})
    },
    // Complete the form submission and redirect and notify
    async resetAndGo(redirect) {
      await this.resetForm()
      this.currentUpdateIdAction()
      if (redirect) {
        await this.route()
      }
    },
    // Close dialog form without any operations
    async beforeClose() {
      await this.resetForm()
      this.currentUpdateIdAction()
      await this.route()
    },
    async route() {
      await this.$router.push({
        name: this.urlResetPathName,
        params: { ...this.urlResetParams },
        query: { ...this.urlResetQueryString },
      })
    },
    checkPermissions() {
      if (this.enableFieldPermissionCheck) {
        let stringCheck = ['root', 'public']
        let allowedPermissionStringCheck = ['new', 'update']
        let getPermissions = this.$helpers.getValue(this.$route, 'meta.permission')
        if (getPermissions) {
          if (typeof getPermissions === 'string') {
            if (stringCheck.includes(getPermissions)) {
              return
            }
          } else if (typeof getPermissions === 'object') {
            let allowed = false
            allowedPermissionStringCheck.forEach(string => {
              let exist = getPermissions.filter(permissionString => permissionString.includes(string))
              allowed = exist.length > 0
            })
            if (allowed) {
              return
            }
          }
        }
        let scopeContainer = document.querySelector(`#${this.formName}`)
        if (scopeContainer) {
          let formElements = scopeContainer.querySelectorAll(
            'input, .q-select, .q-btn, .q-radio, .q-checkbox, .q-toggle, .q-editor, .check-permission, .q-chip, .q-menu'
          )
          if (formElements) {
            for (let index = 0; index < formElements.length; ++index) {
              formElements[index].setAttribute('disabled', 'true')
              formElements[index].classList.add('no-pointer-events')
              formElements[index].classList.add('cursor-not-allowed')
            }
          }
          this.forceDisableSubmit = true
        }
      }
    },
  },
}
</script>
